module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar rowID = '';\nvar primaryKey = 'id';\nvar f, fieldConfig;\nif(resourceData.primaryKey) primaryKey = resourceData.primaryKey;\nif(resourceData.attributes && resourceData.attributes[primaryKey]) rowID = resourceData.attributes[primaryKey];\nvar attributes = resourceData.attributes || {};\nvar additionalClasses = resourceData.additionalClasses || [];\nvar rowGroupTag = 'tbody';\nif(config.isHead) {\nrowGroupTag = 'thead';\nif(config.isSortable){\nadditionalClasses.push('isSortable');\n}\n}\nif(resourceData.selected){\nadditionalClasses.push('selected');\n}\nlet addRowClassViaAttributes = []\nif(utils.isArray(config.addRowClassViaAttribute))   addRowClassViaAttributes = config.addRowClassViaAttribute;\nelse                                                addRowClassViaAttributes = [config.addRowClassViaAttribute];\nfor(const i in addRowClassViaAttributes){\nconst addRowClassViaAttribute = addRowClassViaAttributes[i] || {}\nif(addRowClassViaAttribute){\nif(attributes[addRowClassViaAttribute.fieldCode || '-'] === addRowClassViaAttribute.value && addRowClassViaAttribute.class !== undefined){\nadditionalClasses.push(addRowClassViaAttribute.class)\n}\nif(attributes[addRowClassViaAttribute.fieldCode || '-'] && addRowClassViaAttribute.value === undefined){\nif(addRowClassViaAttribute.class === undefined){\nadditionalClasses.push(attributes[addRowClassViaAttribute.fieldCode || '-'])\n} else {\nadditionalClasses.push(addRowClassViaAttribute.class)\n}\n}\n}\n}\nif(model.highlightRowIDs[rowID]){\nadditionalClasses.push('highlighted');\n}\nvar rowTitle = '';\nfor(f in model.fields){\nif(model.fields[f].showTableFieldAsRowTitle === true && model.fields[f].fieldCode && attributes[model.fields[f].fieldCode]){\nrowTitle = model.fields[f].fieldCode + ': ' + attributes[model.fields[f].fieldCode];\nbreak;\n}\n}\n%><<%- rowGroupTag %> class=\"<%- additionalClasses.join(' ') %>\" data-row-id=\"<%- rowID %>\" data-row-index=\"<%- resourceData.index %>\"<%- (rowTitle ? ' title=\"' + rowTitle + '\"' : '')%>><%\nfor(var rowIndex = 0; rowIndex <= config.maxRowIndex || 0; rowIndex++){\nvar nrOfSubRows = 1\nvar subRowFieldCode = (config.dynamicRowsByMainRowIndex || {})[rowIndex]\nvar subRowFieldKeys = []\nif(!config.isHead && subRowFieldCode){\nsubRowFieldKeys = Object.keys((resourceData.attributes || {})[subRowFieldCode] || {})\nnrOfSubRows = subRowFieldKeys.length\n}\nfor(var subRowIndex = 0; subRowIndex < nrOfSubRows; subRowIndex++){\n%><tr><%\nif(Array.isArray(model.fields)){\nvar resources = {};\nvar column = './col';\nif(config.isHead) column = './headCol';\nfor(f in model.fields){\nmodel.fields[f].colIndex = f;\nfieldConfig = model.fields[f].config || {};\nif(model.fields[f].preventTableField !== true && model.fields[f].hideTableField !== true && rowIndex == (fieldConfig.rowIndex || 0)){\nif(fieldConfig.parentJSONFieldCode){\nconst subResourceAttributes = (resourceData.attributes || {})[fieldConfig.parentJSONFieldCode] || {}\nif(model.fields[f].fieldCode && subResourceAttributes[model.fields[f].fieldCode] !== undefined){\nresources = { value: subResourceAttributes[model.fields[f].fieldCode] };\nmodel.singleValue = true;\n} else {\nresources = { attributes: subResourceAttributes }\nmodel.singleValue = false;\n}\n%><%- include(column, { formMapping: { modelFieldIndex: f }, config: config, model: model, resourceData: resources, rowResourceData: { attributes: subResourceAttributes } }); %><%\n} else if(subRowFieldCode){\nconst subResourceAttributes = ((resourceData.attributes || {})[subRowFieldCode] || {})[subRowFieldKeys[subRowIndex]] || {}\nif(model.fields[f].fieldCode && subResourceAttributes[model.fields[f].fieldCode] !== undefined){\nresources = { value: subResourceAttributes[model.fields[f].fieldCode] };\nmodel.singleValue = true;\n} else {\nresources = { attributes: subResourceAttributes }\nmodel.singleValue = false;\n}\n%><%- include(column, { formMapping: { modelFieldIndex: f }, config: config, model: model, resourceData: resources, rowResourceData: { attributes: subResourceAttributes } }); %><%\n} else {\nif(resourceData.attributes && model.fields[f].fieldCode && resourceData.attributes[model.fields[f].fieldCode] !== undefined){\nresources = { value: resourceData.attributes[model.fields[f].fieldCode] };\nmodel.singleValue = true;\n}\nelse {\nresources = resourceData;\nmodel.singleValue = false;\n}\n%><%- include(column, { formMapping: { modelFieldIndex: f }, config: config, model: model, resourceData: resources, rowResourceData: resourceData }); %><%\n}\n}\n}\n}\nif (rowIndex == 0) {\nif(config.customColActionsFile || config.rowActions.edit || config.rowActions.delete || (config.rowActions.customs || []).length > 0 || config.headRowActions.showSelectColumns) {\n%><%- include('./colActions', { config: config, model: model, resourceData: resourceData }); %><%\n}\n}\n%></tr><%\n}\n}\n%></<%- rowGroupTag %>>"
  , __filename = "..\\frontend-controller\\baseComponents\\tableSimple\\row.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var rowID = '';
var primaryKey = 'id';
var f, fieldConfig;
if(resourceData.primaryKey) primaryKey = resourceData.primaryKey;
if(resourceData.attributes && resourceData.attributes[primaryKey]) rowID = resourceData.attributes[primaryKey];
var attributes = resourceData.attributes || {};
var additionalClasses = resourceData.additionalClasses || [];
var rowGroupTag = 'tbody';
if(config.isHead) {
rowGroupTag = 'thead';
if(config.isSortable){
additionalClasses.push('isSortable');
}
}
if(resourceData.selected){
additionalClasses.push('selected');
}
let addRowClassViaAttributes = []
if(utils.isArray(config.addRowClassViaAttribute))   addRowClassViaAttributes = config.addRowClassViaAttribute;
else                                                addRowClassViaAttributes = [config.addRowClassViaAttribute];
for(const i in addRowClassViaAttributes){
const addRowClassViaAttribute = addRowClassViaAttributes[i] || {}
if(addRowClassViaAttribute){
if(attributes[addRowClassViaAttribute.fieldCode || '-'] === addRowClassViaAttribute.value && addRowClassViaAttribute.class !== undefined){
additionalClasses.push(addRowClassViaAttribute.class)
}
if(attributes[addRowClassViaAttribute.fieldCode || '-'] && addRowClassViaAttribute.value === undefined){
if(addRowClassViaAttribute.class === undefined){
additionalClasses.push(attributes[addRowClassViaAttribute.fieldCode || '-'])
} else {
additionalClasses.push(addRowClassViaAttribute.class)
}
}
}
}
if(model.highlightRowIDs[rowID]){
additionalClasses.push('highlighted');
}
var rowTitle = '';
for(f in model.fields){
if(model.fields[f].showTableFieldAsRowTitle === true && model.fields[f].fieldCode && attributes[model.fields[f].fieldCode]){
rowTitle = model.fields[f].fieldCode + ': ' + attributes[model.fields[f].fieldCode];
break;
}
}

    ; __line = 47
    ; __append("<")
    ; __append( rowGroupTag )
    ; __append(" class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-row-id=\"")
    ; __append( rowID )
    ; __append("\" data-row-index=\"")
    ; __append( resourceData.index )
    ; __append("\"")
    ; __append( (rowTitle ? ' title="' + rowTitle + '"' : ''))
    ; __append(">")
    ; 
for(var rowIndex = 0; rowIndex <= config.maxRowIndex || 0; rowIndex++){
var nrOfSubRows = 1
var subRowFieldCode = (config.dynamicRowsByMainRowIndex || {})[rowIndex]
var subRowFieldKeys = []
if(!config.isHead && subRowFieldCode){
subRowFieldKeys = Object.keys((resourceData.attributes || {})[subRowFieldCode] || {})
nrOfSubRows = subRowFieldKeys.length
}
for(var subRowIndex = 0; subRowIndex < nrOfSubRows; subRowIndex++){

    ; __line = 57
    ; __append("<tr>")
    ; 
if(Array.isArray(model.fields)){
var resources = {};
var column = './col';
if(config.isHead) column = './headCol';
for(f in model.fields){
model.fields[f].colIndex = f;
fieldConfig = model.fields[f].config || {};
if(model.fields[f].preventTableField !== true && model.fields[f].hideTableField !== true && rowIndex == (fieldConfig.rowIndex || 0)){
if(fieldConfig.parentJSONFieldCode){
const subResourceAttributes = (resourceData.attributes || {})[fieldConfig.parentJSONFieldCode] || {}
if(model.fields[f].fieldCode && subResourceAttributes[model.fields[f].fieldCode] !== undefined){
resources = { value: subResourceAttributes[model.fields[f].fieldCode] };
model.singleValue = true;
} else {
resources = { attributes: subResourceAttributes }
model.singleValue = false;
}

    ; __line = 75
    ; __append( include(column, { formMapping: { modelFieldIndex: f }, config: config, model: model, resourceData: resources, rowResourceData: { attributes: subResourceAttributes } }) )
    ; 
} else if(subRowFieldCode){
const subResourceAttributes = ((resourceData.attributes || {})[subRowFieldCode] || {})[subRowFieldKeys[subRowIndex]] || {}
if(model.fields[f].fieldCode && subResourceAttributes[model.fields[f].fieldCode] !== undefined){
resources = { value: subResourceAttributes[model.fields[f].fieldCode] };
model.singleValue = true;
} else {
resources = { attributes: subResourceAttributes }
model.singleValue = false;
}

    ; __line = 85
    ; __append( include(column, { formMapping: { modelFieldIndex: f }, config: config, model: model, resourceData: resources, rowResourceData: { attributes: subResourceAttributes } }) )
    ; 
} else {
if(resourceData.attributes && model.fields[f].fieldCode && resourceData.attributes[model.fields[f].fieldCode] !== undefined){
resources = { value: resourceData.attributes[model.fields[f].fieldCode] };
model.singleValue = true;
}
else {
resources = resourceData;
model.singleValue = false;
}

    ; __line = 95
    ; __append( include(column, { formMapping: { modelFieldIndex: f }, config: config, model: model, resourceData: resources, rowResourceData: resourceData }) )
    ; 
}
}
}
}
if (rowIndex == 0) {
if(config.customColActionsFile || config.rowActions.edit || config.rowActions.delete || (config.rowActions.customs || []).length > 0 || config.headRowActions.showSelectColumns) {

    ; __line = 102
    ; __append( include('./colActions', { config: config, model: model, resourceData: resourceData }) )
    ; 
}
}

    ; __line = 105
    ; __append("</tr>")
    ; 
}
}

    ; __line = 108
    ; __append("</")
    ; __append( rowGroupTag )
    ; __append(">")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\tableSimple\row.ejs

}